import { Component, Input, OnInit } from '@angular/core';
import { GenericTableConfiguration, WidgetConfiguration } from '../../../../../interfaces/WidgetInterfaces';

@Component({
  selector: 'app-generic-table-config',
  template: `<label>Column Rules</label>

<div *ngIf="widgetConfiguration && genericTableConfiguration">
    <div class="form-group row">
        <label class="col-sm-3 tightPad col-form-label">Column</label>
        <label class="col-sm-3 col-form-label">Switch background on change</label>
        <label class="col-sm-2 tightPad col-form-label">Heatmap rule: low</label>
        <label class="col-sm-2 tightPad col-form-label">Heatmap rule: high</label>
        <label class="col-sm-2 tightPad col-form-label">Remove</label>
    </div>
    <div class="form-group row" *ngFor="let rule of genericTableConfiguration.tableColumnRules; let idx = index">

        <div *ngIf="widgetConfiguration.dataConsumerConfiguration.columns; else noColumns" class="col-sm-3">
            <select class="form-control" [(ngModel)]="rule.columnName" id="rulecolumnName">
        <option *ngFor="let name of widgetConfiguration.dataConsumerConfiguration.columns" [ngValue]="name">
                {{name}}
        </option>
      </select>
        </div>
        <ng-template #noColumns>
            <div class="col-sm-3">
                <input type="text" class="form-control" [(ngModel)]="rule.columnName" name="rulecolumnName">
            </div>
        </ng-template>


        <div class="col-sm-3">
            <select class="form-control" [(ngModel)]="rule.alternateColorOnValueChange">
          <option [ngValue]="true">True</option>
          <option [ngValue]="false">False</option>
      </select>
        </div>

        <div class="col-sm-2">
            <input type="text" class="form-control" [(ngModel)]="rule.heatmapRules.low" name="low">
        </div>

        <div class="col-sm-2">
            <input type="text" class="form-control" [(ngModel)]="rule.heatmapRules.high" name="high">
        </div>

        <div class="col-sm-2 tightPad">
            <button type="button" class="btn btn-info btn-sm">
      <span (click)="DeleteByIndex(idx)" class="badge badge-danger"><i _ngcontent-c24="" class="fa fa-times"></i></span>
    </button>
        </div>
    </div>
    <button type="button" class="btn btn-sm btn-secondary" (click)="Add()">Add</button>
</div>`,
  styles: [``]
})
export class GenericTableConfigComponent implements OnInit {

  genericTableConfiguration: GenericTableConfiguration;
  widgetConfiguration: WidgetConfiguration;

  @Input() set widgetConfig(value: WidgetConfiguration) {

    if (value) {
      this.widgetConfiguration = value;
      if (value.config && value.config.tableColumnRules) {
        this.genericTableConfiguration = value.config;
      } else {
        this.genericTableConfiguration = { tableColumnRules : [] };
        value.config = this.genericTableConfiguration;
      }
      this.genericTableConfiguration.tableColumnRules.forEach( tcr =>
        tcr.heatmapRules = tcr.heatmapRules ? tcr.heatmapRules : {low: '', high: '' });
    } else {
      this.genericTableConfiguration = undefined;
      this.widgetConfiguration = undefined;
    }

  }

  constructor() { }

  ngOnInit() { }

  Add() {

    if (this.widgetConfiguration.config === undefined) {
      const config: GenericTableConfiguration = { tableColumnRules: [] };
      this.widgetConfiguration.config = config;
    }

    this.widgetConfiguration.config.tableColumnRules.push({
      columnName: '',
      alternateColorOnValueChange: false,
      heatmapRules: {
        low: '',
        high: ''
      }
    });
  }

  DeleteByIndex(idx: number) {
    this.genericTableConfiguration.tableColumnRules.splice(idx, 1);
  }
}
